export default {"src":"/uk/_next/static/media/spot-monitoring.e2b9895e.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};